import { useGetDetailPromotionCampaign } from "hooks/campaign";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { getQuery } from "utils/helperFuncs";

const useCampaignDetail = () => {
  const { id } = useParams();
  const GET_QUERY = getQuery();

  const [params] = useState({
    id: id,
    withCart: false,
    campaignType: GET_QUERY.campaignType,
    skipTierGroups: GET_QUERY.campaignType === "ORDER_PROMO" || GET_QUERY.campaignType === "LUCKY_WHEEL",
  });

  const { data, loading, refetch } = useGetDetailPromotionCampaign(params);

  return { data, loading, refetch };
};

export default useCampaignDetail;
